import usePlayer from "@/services/store/usePlayer";
import { Box, Button, Grid } from "@mui/material";

const SpeedControl = () => {
  const speed = usePlayer((state) => state.speed);
  const setSpeed = usePlayer((state) => state.setSpeed);

  const handleChangeSpeed = (newSpeed: number) => () => {
    setSpeed(newSpeed);
  };

  const getBackground = (btnSpeed: number) => (theme: ThemeType) => {
    if (speed === btnSpeed) return theme.palette.primary.main;
    return theme.palette.secondary.main;
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item md={4}>
          <Button variant="contained" onClick={handleChangeSpeed(1)} sx={{ background: getBackground(1) }}>
            X 1
          </Button>
        </Grid>
        <Grid item md={4}>
          <Button variant="contained" onClick={handleChangeSpeed(10)} sx={{ background: getBackground(10) }}>
            X 10
          </Button>
        </Grid>
        <Grid item md={4}>
          <Button variant="contained" onClick={handleChangeSpeed(60)} sx={{ background: getBackground(60) }}>
            X 60
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SpeedControl;
